import React, { useState, useEffect } from 'react';
import axios from 'axios';
import GuestTable from '../components/GuestDashboard/GuestTable';
import GuestAnalytics from '../components/GuestDashboard/GuestAnalytics';
import GuestCharts from '../components/GuestDashboard/GuestCharts';

const GuestDashboard = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passes, setPasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('data');

  const checkPasswordAndFetch = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const baseUrl = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
      const res = await axios.get(`${baseUrl}/passes/all-guests`, {
        headers: {
          'x-dashboard-password': password
        }
      });
      
      if (res.data.success) {
        setIsAuthenticated(true);
        setPasses(res.data.passes);
      }
    } catch (err) {
      if (err.response && err.response.status === 403) {
        setError('Incorrect password');
      } else {
        setError('An error occurred while fetching data');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, var(--surface-1) 0%, var(--surface-2) 100%)',
      }}>
        <div style={{
          background: 'var(--surface-1)',
          padding: '40px',
          borderRadius: '16px',
          boxShadow: 'var(--shadow-xl)',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center',
          border: '1px solid var(--border)'
        }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem', fontWeight: 800, marginBottom: '8px' }}>
            Guest Dashboard Access
          </div>
          <p style={{ color: 'var(--text-2)', marginBottom: '24px', fontSize: '0.9rem' }}>
            Please enter the password to view the guest dashboard.
          </p>
          <form onSubmit={checkPasswordAndFetch} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <input
              type="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-field"
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid var(--border)', fontSize: '1rem', width: '100%', boxSizing: 'border-box' }}
            />
            {error && <div style={{ color: 'var(--danger, #dc2626)', fontSize: '0.85rem' }}>{error}</div>}
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
              style={{
                padding: '12px',
                borderRadius: '8px',
                border: 'none',
                background: 'var(--primary, #0f766e)',
                color: 'white',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'Verifying...' : 'Access Dashboard'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  const TabButton = ({ id, label }) => (
    <button
      onClick={() => setActiveTab(id)}
      style={{
        padding: '12px 24px',
        border: 'none',
        background: activeTab === id ? 'var(--primary, #0f766e)' : 'transparent',
        color: activeTab === id ? 'white' : 'var(--text-2)',
        fontWeight: activeTab === id ? 600 : 500,
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '40px 20px', fontFamily: 'var(--font-body)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
          <div>
            <h1 style={{ margin: '0 0 8px 0', fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--text-1)' }}>Global Guest Dashboard</h1>
            <p style={{ margin: 0, color: 'var(--text-2)' }}>Viewing {passes.length} total guests invited by all faculty</p>
          </div>
          <button 
            onClick={() => setIsAuthenticated(false)}
            style={{ padding: '8px 16px', borderRadius: '8px', background: 'var(--surface-2)', border: '1px solid var(--border)', cursor: 'pointer', color: 'var(--text-1)' }}
          >
            Lock Dashboard
          </button>
        </header>

        <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', background: 'var(--surface-1)', padding: '8px', borderRadius: '12px', width: 'fit-content', border: '1px solid var(--border)' }}>
          <TabButton id="data" label="Data Table" />
          <TabButton id="analytics" label="Analytics" />
          <TabButton id="charts" label="Charts" />
        </div>

        <div style={{ background: 'var(--surface-0)', borderRadius: '16px', minHeight: '500px' }}>
          {activeTab === 'data' && <GuestTable passes={passes} />}
          {activeTab === 'analytics' && <GuestAnalytics passes={passes} />}
          {activeTab === 'charts' && <GuestCharts passes={passes} />}
        </div>
      </div>
    </div>
  );
};

export default GuestDashboard;
